export enum DebtResolveType {
  MinPeriod = 'min-period',
  DebtOnly = 'debt-only',
}
